import { parseTradingMethodSpec, METHOD_INVALID, METHOD_UNAVAILABLE } from "./trading-methods.ts";
import type { BacktestFormState } from "./types.ts";

export const RETIRED_TEXT_STRATEGY = "retired_text_strategy";

/** Old records remain readable. A dormant editor draft is not canonical source evidence. */
export function normalizeStrategyEntry(
  form: BacktestFormState,
  canonicalSourceRules?: BacktestFormState["strategyDSL"],
): BacktestFormState {
  const dsl = canonicalSourceRules;
  const hasRules = dsl?.schema_version === 2 && typeof dsl.catalog_version === "string"
    && dsl.short_mode === "mirror_long" && dsl.risk?.mode === "inherit"
    && Array.isArray(dsl.entry?.conditions) && dsl.entry.conditions.length > 0
    && Array.isArray(dsl.exit?.conditions);
  if (form.strategyMode === "manual" && hasRules) {
    return { ...form, strategyMode: "builder", strategyDSL: dsl, useAI: false };
  }
  return { ...form, useAI: false };
}

/** Runs cannot revive retired text input through a draft, history item or link. */
export function requireRunnableStrategy(form: BacktestFormState): BacktestFormState {
  const normalized = normalizeStrategyEntry(form);
  if (normalized.unsupportedMethodExecution) throw new Error(METHOD_UNAVAILABLE);
  if (normalized.strategyMode === "manual") throw new Error(RETIRED_TEXT_STRATEGY);
  if (normalized.strategyMode === "method") {
    const spec = parseTradingMethodSpec(normalized.strategyMethod);
    if (!spec || normalized.strategyDSL) throw new Error(METHOD_INVALID);
    return { ...normalized, strategyMethod: spec };
  } else if (normalized.strategyMethod) throw new Error(METHOD_INVALID);
  return normalized;
}
